import { useQuery } from 'urql';
import { MemberUpdate } from '@/components/Member/MemberUpdate';
import { graphql } from '@/gql/graphql';

const GetAssignableOrganizationRoles = graphql(/* GraphQL */ `
  query GetAssignableOrganizationRoles {
    event_permission_role(
      distinct_on: [role]
      where: { role: { _neq: owner } }
      order_by: [{ role: asc }]
    ) {
      role
    }
  }
`);

export default function OrganizationMemberUpdateRoleInput() {
  const [{ data, fetching }] = useQuery({
    query: GetAssignableOrganizationRoles,
  });
  const roles = data?.event_permission_role || [];

  return (
    <MemberUpdate.RoleInput
      fetching={fetching}
      label="Role"
      roles={roles.map(({ role }) => role)}
      testID="OrganizationMemberUpdateRoleSelect"
    />
  );
}
